export const mixpanelConfig = {
  apiKey: "66a00d09b39f15f2459d2c831cd171b1",
};
